import { render, staticRenderFns } from "./WorkerNotes.vue?vue&type=template&id=4e2de330&scoped=true"
import script from "./WorkerNotes.vue?vue&type=script&lang=ts"
export * from "./WorkerNotes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2de330",
  null
  
)

export default component.exports